export enum OutboundMessageType {
  GetConfig = 'getConfig',
  GetNewAppInstance = 'getNewAppInstance',
}
